export interface ICreateRecipeRequest {
  id?: number;
  name: string;
  restaurantId: number;
  recipeType: string;
  batchSize?: number;
  quantityOnHand?: number;
  isRecipeNested?: boolean;
  unitOfMeasure: { id: number; name: string; abbreviation?: string };
  menuItem?: { id: number; name: string };
  servingSize?: number;
  modifierOption?: { id: number; name: string };
  parLevel?: number;
  shelfLife?: number;
  shelfLifeDuration?: string;
  storageArea?: { id: number; name: string };
  instructions?: string;
  imgUrl?: string;
  totalCost?: number;
  menuPrice?: number;
  recipeIngredients?: IRecipeIngredients[];
}

export interface IRecipeIngredients {
  id?: number;
  type: string;
  ingredient?: { id: number; name: string };
  recipe?: { id: number; name: string };
  quantity: number;
  UOM: { id: number; name: string };
  cost: number;
}

export interface IAllRecipesResponseType {
  response: {
    success: boolean;
    data: { recipes: ICreateRecipeRequest[] } | [];
    message: string;
    error: string | null;
  };
  statusCode: number;
}

export interface IRecipeByIdResponseType {
  response: {
    success: boolean;
    data: { recipe: ICreateRecipeRequest | null };
    message: string;
  };
  statusCode: number;
}

export enum RecipeIngredientTypes {
  INGREDIENT = 'ingredient',
  RECIPE = 'recipe',
}

export enum RecipeTypes {
  PREP_RECIPE = 'Prep Recipe',
  MAIN_RECIPE = 'Main Recipe',
}

export enum RecipeLogsTypes {
  PREP_RECIPE = 'PREP_RECIPE',
  MAIN_RECIPE = 'MAIN_RECIPE',
  MODIFIER_OPTION_RECIPE = 'MODIFIER_OPTION_RECIPE',
}

export enum RecipeLogsSources {
  PREPARE_PREP_LIST = 'PREPARE_PREP_LIST',
  MAIN_RECIPE = 'MAIN_RECIPE',
  MODIFIER_OPTION_RECIPE = 'MODIFIER_OPTION_RECIPE',
  WASTAGE_LOG = 'WASTAGE_LOG',
  STOCK_ADJUSTMENT = 'STOCK_ADJUSTMENT',
}

export enum RecipeLogsActions {
  PREPARATION = 'PREPARATION',
  CONSUMPTION = 'CONSUMPTION',
  WASTED = 'WASTAGE',
  QUANTITY_ADJUSTMENT = 'STOCK_ADJUSTMENT',
}

export enum RecipeLogsItemTypes {
  INGREDIENT = 'INGREDIENT',
  PREP_RECIPE = 'PREP_RECIPE',
}

export enum PrepStatus {
  NOT_STARTED = 'not_started',
  PREPARING = 'preparing',
  COMPLETE = 'complete',
}

export enum PrepListStatus {
  SUBMITTED = 'submitted',
  NOT_SUBMITTED = 'un_submitted',
}

export enum PrepRecipePrepareAction {
  START = 'start',
  STOP = 'stop',
}

export enum RecipeIngredientAction {
  ADD = 'add',
  UPDATE = 'update',
}
export enum RecipeType {
  PREP = 'Prep',
}

export enum RecipeLogFilterEnum {
  POS = 'pos',
  KIOSK = 'kiosk',
  WEBSITE = 'website',
  PREPARE_PREP_LIST = 'PREPARE_PREP_LIST',
  WASTAGE_LOG = 'WASTAGE_LOG',
  STOCK_ADJUSTMENT = 'STOCK_ADJUSTMENT',
  WASTAGE = 'WASTAGE',
  PREPARATION = 'PREPARATION',
  CONSUMPTION = 'CONSUMPTION',
}

export interface IngredientLogItemDto {
  id?: string;
  itemName?: string;
  itemType?: string;
  existingQuantity?: number;
  changeInQuantity?: number;
  newQuantity?: number;
}

export interface PrepRecipeLogDto {
  id: string;
  recipeAction: string;
  source: string;
  existingQuantity: number;
  changeInQuantity: number;
  newQuantity: number;
  createdAt: Date;
  items: IngredientLogItemDto[];
  unitOfMeasure?: string;
  changeType?: string;
}

export interface MainOrModifierRecipeLogDto {
  id: string;
  source: string;
  servingSize: number;
  createdAt: Date;
  items: IngredientLogItemDto[];
  unitOfMeasure?: string;
}
